import "./Todo.css";
import React, { useEffect, useState } from "react";
import { db } from "./firebase-config";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";

const Todo = () => {
  const [grocery, setGrocery] = useState([]);

  const [inputValue, setInputValue] = React.useState("");
  const [quantityValue, setQuantityValue] = React.useState(1);

  const usersCollectionRef = collection(db, "grocery");

  const createGrocery = async () => {
    await addDoc(usersCollectionRef, {
      item: inputValue,
      quantity: quantityValue,
    });

    setInputValue("");
    setQuantityValue(1);

    location.reload();
  };

  useEffect(() => {
    const getGrocery = async () => {
      const data = await getDocs(usersCollectionRef);
      console.log(data);

      const docsRef = data.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      console.log(docsRef);
      setGrocery(docsRef);
    };
    getGrocery();
  }, []);

  // Update Quantity
  const updateQuantity = async (id, currentQuantity) => {
    const usersDoc = doc(db, "grocery", id);
    const newQuantity = { quantity: parseInt(currentQuantity) + 1 }; 

    await updateDoc(usersDoc, newQuantity);
    location.reload();
  };

  //Delete Item
  const deleteItem = async (id) => {
    const usersDoc = doc(db, "grocery", id);
    await deleteDoc(usersDoc);
    location.reload();
  };

  return (
    <div className="todo-container">
      <h2>Grocery List</h2>
      <input
        type="text"
        value={inputValue}
        placeholder="Enter Item"
        onChange={(e) => setInputValue(e.target.value)}
      />
      <input
        type="number"
        placeholder="Enter Quantity"
        value={quantityValue}
        onChange={(e) => setQuantityValue(e.target.value)}
      />

      <button onClick={createGrocery}>Add</button>

      <ul>
        {grocery.map((item) => {
          return (
            <li key={item.id}>
              {item.item} (x{item.quantity})
              <div>
                <button
                  onClick={() => {
                    updateQuantity(item.id, item.quantity);
                  }}
                >
                  Increase Quantity
                </button>
                <button
                  onClick={() => {
                    deleteItem(item.id);
                  }}
                >
                  Delete
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Todo;
